export const adjustDateForTimeZone = (date: Date): Date => {
  // Time zone offset for Armenia Standard Time (GMT+4) in hours
  const timeZoneOffset = 4;
  const newDate = new Date(date);

  newDate.setHours(newDate.getHours() + timeZoneOffset);

  return newDate;
};
